import React from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

import {
  setViewportMobile
} from 'app/actions/viewport';

class Viewport extends React.Component {
  constructor(props) {
    super(props);

    this.handleResize = debounce(this.handleResize.bind(this), 1000);
  }

  componentDidMount() {
    // detect viewport on first mount
    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    const { setViewportMobile } = this.props;

    // set the viewport mobile flag.
    // assume the viewport is mobile if the screen's height is greater
    const isMobile = window.innerHeight > window.innerWidth;
    setViewportMobile(isMobile);
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { setViewportMobile })(Viewport);
